import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import { isBrowser } from 'utils/browser';

import Button from 'components/layout/Button';
import SaveButton from 'components/modules/public/layout/controls/SaveButton';
import ShareButton from 'components/modules/public/layout/controls/ShareButton';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionJobBlocksJobHeaderMobile: FunctionComponent<Props> = ({
    job,
    jobCity,
    buttonProps,
    title,
}) => {
    const router = useRouter();

    return (
        <StyledComponent
            className="public-page-job-section-job-blocks-job-header-mobile"
        >

            <div
                className="title"
                dangerouslySetInnerHTML={{ __html: title }}
            />
            {!job?.isClosed && (
                <div className="controls">
                    <SaveButton
                        jobId={job.id}
                        cityId={jobCity?.city?.id}
                        disabled={job?.isClosed}
                    />
                    <ShareButton
                        route={Routes.PublicJob}
                        variables={{
                            slug: job.slug,
                        }}
                        disabled={job?.isClosed}
                    />
                </div>
            )}
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobHeaderMobile;